// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"43afb820","328":"fbdb7cb6","368":"090df420","382":"a11bfaf8","439":"c5d9eefc","476":"43afb820","543":"3807d0e9","623":"223640db","663":"ac78fbf2"}[chunkId] + ".chunk.css";
};